import React from "react";
import { Link } from "react-router-dom";
import "./Sections.css";
import logo from "../header/cullycode.png";

const Sections = () => (
  <main className="sections">

    {/* ── Hero ── */}
    <section className="hero">
      <div className="hero__container">
        <img className="hero__logo" src={logo} alt="Cully Code" />
        <h1 className="hero__title">We build apps people love.</h1>
        <p className="hero__subtitle">iOS &amp; Android apps. Web apps. Contract engineering.</p>
        <a href="#contact" className="hero__cta">Get in touch</a>
      </div>
    </section>

    {/* ── Products ── */}
    <section id="products" className="products">
      <div className="products__container">
        <h2 className="section-heading">Products</h2>
        <div className="products__card">
          <img
            className="products__icon"
            src="/namizen.png"
            alt="NamiZen app icon"
            width="80"
            height="80"
            loading="lazy"
          />
          <div className="products__info">
            <h3 className="products__name">NamiZen</h3>
            <p className="products__desc">
              A beautifully calm contraction timer for labour. Track contractions,
              breathe through each one, and know when it's time to call your midwife.
            </p>
            <Link to="/namizen" className="products__link">Learn more &rarr;</Link>
          </div>
        </div>
      </div>
    </section>

    {/* ── Services ── */}
    <section id="services" className="services">
      <div className="services__container">
        <h2 className="section-heading">Services</h2>
        <div className="services__grid">
          <div className="services__item">
            <h3>Mobile Development</h3>
            <p>Native iOS and Android apps, from concept through store launch.</p>
          </div>
          <div className="services__item">
            <h3>Web Development</h3>
            <p>Responsive web apps and sites using modern frameworks and best practices.</p>
          </div>
          <div className="services__item">
            <h3>Contract Engineering</h3>
            <p>Delivering projects and specialist expertise to complement your existing team. Scoped engagements with clear deliverables.</p>
          </div>
        </div>
      </div>
    </section>

    {/* ── Contact ── */}
    <section id="contact" className="contact">
      <div className="contact__container">
        <h2 className="section-heading">Get in touch</h2>
        <p className="contact__text">
          Have a project in mind, or need an experienced developer on your team?
        </p>
        <a href="mailto:hello@cullycode.co.uk" className="contact__cta">hello@cullycode.co.uk</a>
        <div className="contact__social">
          <a href="https://www.linkedin.com/in/thomas-cullinane-01531831/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="https://github.com/cullycode" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
      </div>
    </section>

    {/* ── Footer ── */}
    <footer className="footer">
      <p>Cully Code LIMITED</p>
      <p>VAT Number: 282109513</p>
      <p>Companies House Number: 11054042</p>
      <p>Copyright &copy; {new Date().getFullYear()}</p>
    </footer>
  </main>
);

export default Sections;
